import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import moment from "moment";
import { baseUrl } from "../../../api";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    background: "#ffffff",
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    padding: 20
  },
  paper: {
    position: "absolute",
    width: "40%",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    marginTop: 70,
    left: "30%",
  },
  fullWidth: {
    width: "100%",
  },
}));

export default function HistoryModal({
  selectedHistory,
  handleClose,
  joinMeeting,
}) {
  const classes = useStyles();
  const [history, setHistory] = useState(selectedHistory);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Chargement en cours...");
  const [editNote, setEditNote] = useState(false);
  const [editComment, setEditComment] = useState(false);
  const [editedComment, setEditedComment] = useState(selectedHistory?.comment);
  const [editedNotes, setEditedNotes] = useState(selectedHistory?.notes);

  const updateNote = () => {
    setLoading(true);
    let payload = {
      meeting_id: selectedHistory.meeting_id,
      notes: editedNotes,
      comment: editedComment,
    };

    let url = `${baseUrl}/update_meeting_detail`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.statusCode === 200) {
          setEditComment(false);
          setEditNote(false);
          setHistory((prev) => {
            return {
              ...prev,
              notes: res.response.detail.notes,
              comment: res.response.detail.comment,
            };
          });

          setLoading(false);
        } else {
          setLoadingText("Something went wrong please try again later!");
        }
      })
      .catch((err) => console.log(err));
  };


  const handleReSubmit = (id) => {
    console.log("Idpass",id)
    setLoading(true);
    let payload = {
      meeting_id: id,
    };

    let url = `${baseUrl}/resend_email`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.statusCode === 200) {
          console.log("response",res?.message)

          setLoading(true);
          setLoadingText(res?.message);
          setTimeout(() => {
            setLoading(false);

          }, 2000);

        } else {
          setLoadingText("Something went wrong please try again later!");
          setTimeout(() => {
            setLoading(false)
          }, 2000);
        }
      })
      .catch((err) => console.log(err));
  };
 
  return (
    <div>
      <Modal
        open={true}
        onClose={() => handleClose(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {Boolean(selectedHistory) && (
          <div
            // className={`col-sm-12 col-md-12 col-lg-6 mb-sm-4 ${classes.wrapper}`}
            className={classes.wrapper}

          >
            <div className="row mb-3" style={{ background: "#FF7900" }}>
              <div
                className="col-10 mt-1"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Détail de la visioconférence
              </div>
              <div className="col-2">
                <button
                  className="btn btn-sm btn-secondary btn-secondary-cust"
                  style={{ marginLeft: 20, height: 30 }}
                  onClick={() => handleClose(false)}
                >
                  <b>X</b>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12 conference-title">
                <div
                  className="text-darkcust badge badge-cust bg-light"
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <span style={{ textTransform: "uppercase" }}>{selectedHistory?.user_detail?.user_name}{" "}</span>
                  {selectedHistory?.user_detail?.user_surname}
                </div>
                <div className="col-12 conference-title">
                <div
                  className="text-darkcust badge badge-cust bg-light"
                  style={{
                    width: "100%",
                    textAlign: "left",
                    marginTop:"5px"
                  }}
                >
                  RDV :{" "}
                  {moment(selectedHistory?.appointment_date).format(
                    "DD-MM-YYYY"
                  )}{" "}
                  {selectedHistory?.appointment_time?.slice(0, 5)}
                </div>
              </div>

                <div className="text-darkcust mt-2">
                  Visioconférence&nbsp;
                  {selectedHistory?.meeting_name}
                  <br />
                  créée le  {moment(selectedHistory.addedon).format(
                    "DD/MM/YYYY à HH:mm"
                  )}
                </div>
              </div>
                         </div>
            <div className="row">
              <div className="col-1 mb-2" style={{ textAlign: "center" }}>
                <img src={"./images/letter.svg"} className="icon" />
              </div>
              <div className="col-11 mb-2 text-darkcust">
                {" "}
                <b>
                  {selectedHistory?.user_detail?.user_email || "Non renseigné"}
                </b>
              </div>
              <div className="col-1" style={{ textAlign: "center" }}>
                <img src={"./images/phone.svg"} className="icon" />{" "}
              </div>
              <div className="col-11 text-darkcust">
                <b>
                  {selectedHistory?.user_detail?.user_phone || "Non renseigné"}
                </b>
              </div>

              <div className="col-12">
                <div className="row">
                  <h4 className="col-8 text-dark fw-bold lead mb-0 mt-2">
                    Commentaire conseiller
                  </h4>
                  <div className="col-4">
                    {!editComment && (
                      <button
                        className="btn btn-sm btn-link"
                        onClick={() => setEditComment(true)}
                      >
                        Modifier
                      </button>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div
                    className={`text-darkcust commentdetail col-12 ${editComment && "d-none"
                      } `}
                  >
                    {history?.comment || "Non renseigné"}
                  </div>
                  <div className={`col-12 ${!editComment && "d-none"}`}>
                    <textarea
                      className="form-control"
                      value={editedComment}
                      onChange={(e) => setEditedComment(e.target.value)}
                      rows="7"
                      style={{
                        fontSize: "10pt",
                        fontWeight: "normal",
                        minHeight: "70px",
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <h4 className="col-8 text-dark fw-bold lead mb-0 mt-2">
                    Notes:
                  </h4>
                  <div className="col-4">
                    {!editNote && (
                      <button
                        className="btn btn-sm btn-link"
                        onClick={() => setEditNote(true)}
                      >
                        Modifier
                      </button>
                    )}
                  </div>
                </div>
                <div className={`row `}>
                  <div
                    className={`text-darkcust col-12 ${editNote && "d-none"} `}
                    style={{ fontSize: "10pt", fontWeight: "normal" }}
                  >
                    {history?.notes || "Non renseigné"}
                  </div>
                  <div className={`col-12 ${!editNote && "d-none"}`}>
                    <input
                      type="text"
                      className="form-control"
                      value={editedNotes}
                      onChange={(e) => setEditedNotes(e.target.value)}
                      style={{ fontSize: "10pt", fontWeight: "normal" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col col-sm-6">
                {(editNote || editComment) && (
                  <button
                    className="join-btn btn btn-sm btn-light"
                    onClick={() => updateNote(editedNotes, editedComment)}
                  >
                    Enregistrer
                  </button>
                )}
              </div>
              <div className="col col-sm-6">
              {/* <button
                  className="join-btn btn btn-sm btn-light"
                  onClick={() =>
                   handleReSubmit (
                      selectedHistory.meeting_id
                    )
                  }
                >
                  Renvoyer
                </button> */}
                <button style={{marginLeft:"10px"}}
                  className="join-btn btn btn-sm btn-light"
                  onClick={() =>
                    joinMeeting(
                      selectedHistory.meeting_name,
                      selectedHistory.meeting_id,
                      selectedHistory?.user_detail?.user_email
                    )
                  }
                >
                  Démarrer
                </button>
               
              </div>
            </div>
            <div className="row">
              {loading && (
                <div className="loading text-center">{loadingText}</div>
              )}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
